// news.js
// Firebase news collection API functions

import { 
  collection, 
  doc, 
  getDoc, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc,
  serverTimestamp,
  query,
  orderBy
} from 'firebase/firestore';
import { db } from '../firebaseConfig';

const NEWS_COLLECTION = 'news';

/**
 * Get all news posts
 */
export const getAllNews = async () => {
  try {
    const newsRef = collection(db, NEWS_COLLECTION);
    const q = query(newsRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const newsPosts = [];
    querySnapshot.forEach((doc) => {
      newsPosts.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    
    return newsPosts;
  } catch (error) {
    console.error('Error getting news:', error);
    throw error;
  }
};

/**
 * Get news post by ID
 */
export const getNewsById = async (newsId) => {
  try {
    const newsDoc = await getDoc(doc(db, NEWS_COLLECTION, newsId));
    
    if (newsDoc.exists()) {
      return {
        id: newsDoc.id,
        ...newsDoc.data(),
      };
    } else {
      throw new Error('News post not found');
    }
  } catch (error) {
    console.error('Error getting news post:', error);
    throw error;
  }
};

/**
 * Create new news post
 */
export const createNews = async (newsData) => {
  try {
    const newsRef = collection(db, NEWS_COLLECTION);
    
    const newNewsPost = {
      ...newsData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    const docRef = await addDoc(newsRef, newNewsPost);
    
    return {
      id: docRef.id,
      ...newNewsPost,
    };
  } catch (error) {
    console.error('Error creating news post:', error);
    throw error;
  }
};

/**
 * Update news post
 */
export const updateNews = async (newsId, newsData) => {
  try {
    const newsRef = doc(db, NEWS_COLLECTION, newsId);
    
    const updatedData = {
      ...newsData,
      updatedAt: serverTimestamp(),
    };

    await updateDoc(newsRef, updatedData);
    
    return {
      id: newsId,
      ...updatedData,
    };
  } catch (error) {
    console.error('Error updating news post:', error);
    throw error;
  }
};

/**
 * Delete news post
 */
export const deleteNews = async (newsId) => {
  try {
    const newsRef = doc(db, NEWS_COLLECTION, newsId);
    await deleteDoc(newsRef);
  } catch (error) {
    console.error('Error deleting news post:', error);
    throw error;
  }
};

/**
 * Get recent news posts (limited)
 */
export const getRecentNews = async (limit = 5) => {
  try {
    const newsRef = collection(db, NEWS_COLLECTION);
    const q = query(newsRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const newsPosts = [];
    let count = 0;
    
    querySnapshot.forEach((doc) => {
      if (count < limit) {
        newsPosts.push({
          id: doc.id,
          ...doc.data(),
        });
        count++;
      }
    });
    
    return newsPosts;
  } catch (error) {
    console.error('Error getting recent news:', error);
    throw error;
  }
};
